module.exports = __webpack_public_path__ + "static/logo-rac-84c9b434d005991c42006ad1e17f19f7.png";